(function() {
  function forceProductPriceText() {
    var priceEls = document.querySelectorAll('#ProductPrice');
    for (var i = 0; i < priceEls.length; i++) {
      if (priceEls[i].textContent.trim() !== 'Price upon request') {
        priceEls[i].textContent = 'Price upon request';
      }
    }

    var comparePriceEls = document.querySelectorAll('#ComparePrice');
    for (var j = 0; j < comparePriceEls.length; j++) {
      comparePriceEls[j].classList.add('hide');
      comparePriceEls[j].innerHTML = '';
    }

    var gridPriceEls = document.querySelectorAll('.grid-link__meta');
    for (var k = 0; k < gridPriceEls.length; k++) {
      if (gridPriceEls[k].textContent.trim() !== 'Price upon request') {
        gridPriceEls[k].textContent = 'Price upon request';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', forceProductPriceText);
  window.addEventListener('load', forceProductPriceText);

  if (window.MutationObserver) {
    document.addEventListener('DOMContentLoaded', function() {
      var target = document.body;
      if (!target) return;
      var observer = new MutationObserver(function() {
        forceProductPriceText();
      });
      observer.observe(target, { childList: true, subtree: true, characterData: true });
    });
  }
})();
